'use es6';

import { createAsyncAction } from 'conversations-async-data/async-action/createAsyncAction';
import { getFileStatus } from '../client/getFileStatus';
import { EMAIL_MESSAGE_IMAGE_STATUS_FETCH } from 'conversations-thread-data/email-inline-images/public/constants/asyncActionTypes';
export const fetchImageProcessingStatusById = createAsyncAction({
  requestFn: getFileStatus,
  actionTypes: EMAIL_MESSAGE_IMAGE_STATUS_FETCH,
  toRecordFn: response => response
});